var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCribs = function SvgCribs(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.6,
    y: 283.78,
    width: 18.78,
    height: 123.45,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.17,173.92a6.92,6.92,0,0,0,6.85,6.89,7.06,7.06,0,0,0,7.09-7.08,7,7,0,1,0-13.94.19Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.46,
    y: 283.78,
    width: 17.14,
    height: 123.45,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.19,
    y: 283.78,
    width: 17.81,
    height: 123.45,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.96,
    y: 283.78,
    width: 20.48,
    height: 123.45,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 283.78,
    width: 17,
    height: 123.45,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.98,
    y: 283.78,
    width: 13.78,
    height: 123.45,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.6 407.23 333.83 407.23 333.83 285.37 275.07 285.37 275.07 407.23 299 407.23 299 285.39 306.83 285.39 313.6 285.39 313.6 407.23",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "541.6 407.23 551.76 407.23 551.76 285.37 372.46 285.37 372.46 407.23 378.98 407.23 378.98 285.39 386.81 285.39 393.58 285.39 393.58 407.23 416.71 407.23 416.71 285.39 424.54 285.39 431.31 285.39 431.31 407.23 454.12 407.23 454.12 285.39 461.95 285.39 468.72 285.39 468.72 407.23 491.85 407.23 491.85 285.39 499.68 285.39 506.45 285.39 506.45 407.23 527 407.23 527 285.39 534.83 285.39 541.6 285.39 541.6 407.23",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.92,
    y: 498.15,
    width: 11.54,
    height: 80.74,
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.46,243.5v-7.94H360.92v12.79C364.36,246.72,368.2,245.08,372.46,243.5Z",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.46 407.23 372.46 285.37 360.92 285.37 360.92 285.39 354.23 285.39 354.23 459.85 361 459.85 361 407.23 372.46 407.23",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.44,262.49s7.27-6.94,22.48-14.14V235.56H333.83V271.2h4.61Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.92 285.39 360.92 285.37 333.83 285.37 333.83 407.23 346.41 407.23 346.41 285.39 354.23 285.39 360.92 285.39",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.83 498.15 333.83 578.89 358.92 578.89 360.92 578.89 360.92 498.15 333.83 498.15",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.45,
    y: 407.22,
    width: 20.55,
    height: 52.63,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.19,
    y: 407.22,
    width: 17.81,
    height: 52.63,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.31,
    y: 407.22,
    width: 22.81,
    height: 52.63,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.35,
    y: 407.22,
    width: 17,
    height: 52.63,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.6,
    y: 407.22,
    width: 18.78,
    height: 52.63,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.58,
    y: 407.22,
    width: 23.13,
    height: 52.63,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.98,
    y: 407.22,
    width: 13.78,
    height: 52.63,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.07,
    y: 407.22,
    width: 23.93,
    height: 52.63,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.96,
    y: 407.22,
    width: 20.48,
    height: 52.63,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.6 407.23 313.6 459.85 346.41 459.85 346.41 407.23 333.83 407.23 313.6 407.23",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.6,
    y: 407.22,
    width: 10.16,
    height: 52.63,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.72,
    y: 407.22,
    width: 23.13,
    height: 52.63,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.46,
    y: 407.22,
    width: 17.14,
    height: 52.63,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361 407.23 361 459.85 378.98 459.85 378.98 407.23 372.46 407.23 361 407.23",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.46 459.85 56.46 459.85 56.46 407.23 56.46 283.78 42.91 283.78 42.91 578.89 53.91 578.89 56.46 578.89 56.46 498.15 55.46 498.15 55.46 459.85",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.46,253.05V235.56H42.91v28.8A78.28,78.28,0,0,1,56.46,253.05Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.52,235.56H234.44v19.05C220.32,243.86,190.52,232,127.8,232.5c-34.45.29-57.87,11.41-71.34,20.55a78.28,78.28,0,0,0-13.55,11.31v-28.8H26.82V578.89H42.91V283.78H73.59V459.85H55.46v38.3h179v80.74h27.08ZM88.19,459.85H81.42V283.78H106V459.85Zm32.41,0h-6.77V283.78h25.55V459.85Zm33.38,0H147.2V283.78h20.56V459.85Zm28.37,0h-6.77V283.78h23.78V459.85Zm31.61,0h-6.77V283.78h27.25V459.85Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.85,268.3V235.56H551.76V251c-14.43-6.28-35.61-12.65-65.8-16V115.66c0-43.64-28.77-79.14-64.15-79.14H369.68c-14,0-25.88,11.33-29.72,26.83a10.51,10.51,0,0,1,4.68-1.11,10.4,10.4,0,0,1,5.54,1.6c3.12-10.14,10.68-17.32,19.5-17.32h52.13c29.86,0,54.15,31,54.15,69.14V234c-11.23-1-23.59-1.49-37.18-1.49-28.3,0-50.25,5.05-66.32,11-4.26,1.58-8.1,3.22-11.54,4.85-15.21,7.2-22.48,14.14-22.48,14.14v8.71H275.07V235.56H261.52V578.89h13.55V498.15H551.76v80.74h27.09V268.3ZM541.6,459.85h-6.77V285.39H527V459.85H499.68V285.39h-7.83V459.85H462V285.39h-7.83V459.85H424.54V285.39h-7.83V459.85h-29.9V285.39H379V459.85H354.23V285.39h-7.82V459.85H306.83V285.39H299V459.85H275.07V285.37H551.76V459.85Z",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "578.85 235.56 578.85 268.3 578.85 279.91 578.85 578.89 592.39 578.89 592.39 235.56 578.85 235.56",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "541.6 285.39 534.83 285.39 534.83 459.85 541.6 459.85 541.6 407.23 541.6 285.39",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "506.45 285.39 499.68 285.39 499.68 459.85 506.45 459.85 506.45 407.23 506.45 285.39",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.72 285.39 461.95 285.39 461.95 459.85 468.72 459.85 468.72 407.23 468.72 285.39",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.31 285.39 424.54 285.39 424.54 459.85 431.31 459.85 431.31 407.23 431.31 285.39",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.58 285.39 386.81 285.39 386.81 459.85 393.58 459.85 393.58 407.23 393.58 285.39",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.6 285.39 306.83 285.39 306.83 459.85 313.6 459.85 313.6 407.23 313.6 285.39",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.96 283.78 207.19 283.78 207.19 459.85 213.96 459.85 213.96 407.23 213.96 283.78",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.35 283.78 175.58 283.78 175.58 459.85 182.35 459.85 182.35 407.23 182.35 283.78",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.98 283.78 147.2 283.78 147.2 459.85 153.98 459.85 153.98 407.23 153.98 283.78",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.6 283.78 113.83 283.78 113.83 459.85 120.6 459.85 120.6 407.23 120.6 283.78",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.19 283.78 81.42 283.78 81.42 459.85 88.19 459.85 88.19 407.23 88.19 283.78",
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.83,176.47a4,4,0,0,1-2.77-.6c-2.81-1.74-5.73-3.31-8.63-4.9-.82-.46-1.68-1.14-2.68-.31a2.62,2.62,0,0,0-.71,2.68c.5,3.17,1,6.33,1.52,9.5.54,3.39-.05,6.36-2.83,8.72-2.31,1.95-4.49,4-6.67,6.12-.95.91-2.45,1.66-1.93,3.31s2.06,1.52,3.4,1.74c3.27.54,6.53,1.07,9.78,1.71a7.76,7.76,0,0,1,5.94,4.69c1.42,3.2,2.83,6.42,4.35,9.58,1.23,2.57,2.75,2.65,4.15.18a79.77,79.77,0,0,0,4-7.82c1.94-4.47,5.32-6.41,10.09-6.59a55,55,0,0,0,8.66-1.12c1.74-.34,2.64-1.45,1-3.11-2-2-3.63-4.31-5.89-6.06a10.17,10.17,0,0,1-3.9-11.4c.65-2.54,1-5.15,1.53-7.73.24-1.22.9-2.59-.34-3.53s-2.57.06-3.8.59c-3.11,1.36-5.92,3.38-9.26,4.24a5.46,5.46,0,0,1-.75.4V83.27h-4.28Z",
    fill: "#7dc0ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.79,77.81V79l2.64-1.14Z",
    fill: "#7dc0ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.79,149.27l3.48,0V89.54c-1.21.56-2.37,1.11-3.48,1.66Z",
    fill: "#7dc0ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.59,151l1.06-.68c.8-.3,1.6-.59,2.42-.86V94.52c-1.11-.67-2.26-1.35-3.48-2Z",
    fill: "#7dc0ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,63.35a10.49,10.49,0,0,0-4.45,4.2,135.87,135.87,0,0,0-44.08,10.26L288.79,79c-14.73,6.58-23,13.6-23.65,14.15a5.5,5.5,0,0,0,7.19,8.32A89.53,89.53,0,0,1,288.79,91.2c1.11-.55,2.27-1.1,3.48-1.66a125.14,125.14,0,0,1,43.6-11,10.51,10.51,0,0,0,17.44.14c17,1.65,31.7,7.86,42.28,13.79,1.22.68,2.37,1.36,3.48,2a103.82,103.82,0,0,1,14.17,10.07,5.5,5.5,0,1,0,7.4-8.13c-1.21-1.11-28.23-25.28-66.79-28.77a10.51,10.51,0,0,0-3.67-3.85,10.4,10.4,0,0,0-5.54-1.6A10.51,10.51,0,0,0,340,63.35Z",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.59,151l-4.24,2.73c-6.92,6.54-10.39,14.3-9,24,2.7,18.47,24.72,27.94,39.93,17.08.59-.41,1.54-.61,1.31-1.78-11-1.07-19.13-6.38-23.07-17s-.66-19.74,7.13-28a24.47,24.47,0,0,0-8.61,1.37c-.82.27-1.62.56-2.42.86Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.66,149.28c-3.08,1.84-5.74,4-6.34,7.85-.25,1.6-1.38,1.22-2.42,1.06a9.38,9.38,0,0,0-9.85,4.33c-2.54,3.75-2.2,7.57.16,11.13.94,1.42,1.22,2.31.55,4-3,7.56,1.23,14.05,9.34,14.32a3.65,3.65,0,0,1,3.62,2c2.09,3.65,5.54,4.8,9.56,4.38a8.76,8.76,0,0,0,7.75-6.18c.8-2.3,1.84-3.17,4.24-2.93,4,.39,7.12-1.16,8.89-4.83s2-7.43-.83-10.79c-1.12-1.3-.82-2.42-.26-3.84,3-7.44-1.13-13.82-9.07-14.16-1.14-.05-2.38.24-3-1.15-1.14-2.44-3.32-3.8-5.46-5.21h-.25l-3.48,0Zm10.45,24.45a7.06,7.06,0,0,1-7.09,7.08,6.92,6.92,0,0,1-6.85-6.89,7,7,0,1,1,13.94-.19Z",
    fill: "#f4abe0"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCribs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cribs.cfd58a0c.svg";
export { ForwardRef as ReactComponent };